import { ActionTypes } from "../constants";
import { idAsNumber, addIoItem, updateIoItem, updateFormElement } from "../utilities/reducers";


const reduceAppraisals = (state = [], action) => {
    let appraisal;
    switch (action.type) {
        case ActionTypes.GET_RMS_APPRAISALS_SUCCESS:
            return action.data.map(idAsNumber);

        case ActionTypes.GET_RMS_APPRAISAL_DETAILS_SUCCESS:
            return !state
                ? [action.data]
                : [
                    ...state.filter(({id}) => Number(id) !== Number(action.data.id)),
                    action.data
                ];

        case ActionTypes.ADD_RMS_APPRAISAL_SUCCESS:
            return !state ? [action.data] : [...state, action.data];

        case ActionTypes.UPDATE_RMS_APPRAISAL_SUCCESS:
            appraisal = state.find(({id}) => Number(id) === Number(action.payload.id));
            if (!appraisal) { return state; }

            return [
                ...state.filter(({id}) => Number(id) !== Number(action.payload.id)),
                {
                    ...appraisal,
                    ...action.payload.params,
                    meeting: {
                        ...appraisal.meeting,
                        ...(action.payload.params.meeting || {})
                    }
                }
            ];


        case ActionTypes.ADD_QUALIFICATION_SUCCESS:
            return addIoItem(state, action, ['qualifications']);

        case ActionTypes.GET_QUALIFICATION_SUCCESS:
            return state.map((appraisal) => updateIoItem(appraisal, ['qualifications'], action.data.id, action.data));

        case ActionTypes.UPDATE_QUALIFICATION_SUCCESS:
            return state.map((appraisal) => updateIoItem(appraisal, ['qualifications'], action.payload.id, action.payload.params));

        case ActionTypes.DELETE_QUALIFICATION_SUCCESS:
            return state.map((appraisal) => updateIoItem(appraisal, ['qualifications'], action.payload.id, null));


        case ActionTypes.ADD_SCOPE_OF_WORK_SUCCESS:
            return addIoItem(state, action, ['scopeOfWork']);

        case ActionTypes.GET_SCOPE_OF_WORK_SUCCESS:
            return state.map((appraisal) => updateIoItem(appraisal, ['scopeOfWork'], action.data.id, action.data));

        case ActionTypes.UPDATE_SCOPE_OF_WORK_SUCCESS:
            return state.map((appraisal) => updateIoItem(appraisal, ['scopeOfWork'], action.payload.id, action.payload.params));

        case ActionTypes.DELETE_SCOPE_OF_WORK_SUCCESS:
            return state.map((appraisal) => updateIoItem(appraisal, ['scopeOfWork'], action.payload.id, null));


        case ActionTypes.ADD_DEVELOPMENT_NEED_SUCCESS:
            return addIoItem(state, action, ['developmentneeds', 'pdp']);

        case ActionTypes.UPDATE_DEVELOPMENT_NEED_SUCCESS:
            return state.map((appraisal) => updateIoItem(appraisal, ['pdp-review', 'pdp', 'developmentneeds'], action.payload.id, action.data));

        case ActionTypes.DELETE_DEVELOPMENT_NEED_SUCCESS:
            return state.map((appraisal) => updateIoItem(appraisal, ['pdp-review', 'pdp', 'developmentneeds'], action.payload.id, null));


        case ActionTypes.ADD_ACTIVITY_SUCCESS:
            if (!action.payload?.appraisalId || !action.payload?.inputSegmentId) { return state; }
            appraisal = state.find(({id}) => Number(id) === Number(action.payload.appraisalId));
            const segment = appraisal.inputs.segments.find(({index}) => Number(index) === Number(action.payload.inputSegmentId));
            return [
                ...state.filter(({id}) => Number(id) !== Number(action.payload.appraisalId)),
                {
                    ...appraisal,
                    inputs: {
                        ...appraisal.inputs,
                        segments: [
                            ...appraisal.inputs.segments.filter(({index}) => Number(index) !== Number(action.payload.inputSegmentId)),
                            {
                                ...segment,
                                items: [
                                    ...segment.items,
                                    action.data
                                ]
                            }
                        ]
                    }
                }
            ];

        case ActionTypes.UPDATE_ACTIVITY_SUCCESS:
            return state.map((appraisal) => updateIoItem(appraisal, ['activities'], action.payload.id, action.data));

        case ActionTypes.DELETE_ACTIVITY_SUCCESS:
            return state.map((appraisal) => updateIoItem(appraisal, ['activities'], action.payload.id, null));


        case ActionTypes.UPDATE_RMS_APPRAISAL_FORM_ELEMENT_SUCCESS:
            const updatedElement = action.payload.params?.elements[0];
            if (!updatedElement || !updatedElement.id ) { return state; }
            appraisal = state.find(({id}) => Number(id) === Number(action.payload.id));
            if (!appraisal) { return state; }

            return updateFormElement(state, updatedElement, appraisal);


        case ActionTypes.LOGOUT:
            return null;

        default:
            return state;
    }
};

export default reduceAppraisals;

export const getAppraisals = (appraisals) => appraisals || [];
